import { render, staticRenderFns } from "./PropertyFeatures.vue?vue&type=template&id=b9480304"
import script from "./PropertyFeatures.vue?vue&type=script&lang=js"
export * from "./PropertyFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports